module.exports = __webpack_public_path__ + "files/f9017268842230e60b41aca18d467093.eot";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/pt_sans-web-bolditalic-webfont.eot
// module id = 354
// module chunks = 60